import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ComponentType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { ComponentTypes } from '@wix/editor-const';
import { ManifestComponentExtensionType } from '../ManifestStore';
import { ManifestStructureHelpers } from './ManifestStructureHelpers';
const TPAComponentTypes = [ComponentTypes.TpaMultiSection, ComponentTypes.TpaSection, ComponentTypes.TpaWidget, ComponentTypes.TpaGluedWidget];
export class ManifestHelpers {
  constructor(dm, editorPointerAPI) {
    this.dm = dm;
    this.editorPointerAPI = editorPointerAPI;
    _defineProperty(this, "structure", void 0);
    this.structure = new ManifestStructureHelpers(this.editorPointerAPI);
  }
  isInnerElement(manifest) {
    return manifest.behaviors !== undefined;
  }
  isTopLevelElement(editorPointer) {
    const innerElementPath = this.editorPointerAPI.getInnerElementPath(editorPointer);
    return !innerElementPath || innerElementPath.length <= 1;
  }
  getAppData(compType) {
    if (!compType) {
      return null;
    }
    try {
      const componentData = this.dm.builder.components.getCompAppData(compType);
      if (!componentData) {
        return null;
      }
      const {
        appDefinitionId
      } = componentData;
      return this.dm.platform.getAppDataByAppDefId(appDefinitionId);
    } catch (error) {
      // console.warn(`Could not check component type '${compType}':`, error);
      return null;
    }
  }
  getAppComponentData(compType) {
    var _appData$components;
    if (!compType) {
      return null;
    }
    const componentData = this.dm.builder.components.getCompAppData(compType);
    if (!componentData) {
      return null;
    }
    const {
      componentId
    } = componentData;
    const appData = this.getAppData(compType);
    const appDataComponent = appData == null || (_appData$components = appData.components) == null ? void 0 : _appData$components.find(component => component.componentId === componentId);
    if (!appDataComponent) {
      return null;
    }
    return appDataComponent;
  }
  isBuilderComponentType(compType) {
    var _appComponent$data;
    if (compType && TPAComponentTypes.includes(compType)) {
      return true;
    }
    const appData = this.getAppComponentData(compType);
    if (!appData) {
      return false;
    }
    const appComponentData = this.getAppComponentData(compType);
    if (!appComponentData) {
      return false;
    }
    return appComponentData.type === ComponentType.EDITOR_REACT_COMPONENT || appComponentData.type === ComponentType.STUDIO_WIDGET && (// @ts-expect-error no componentModel in the AppDataComponent type
    (_appComponent$data = appComponent.data) == null || (_appComponent$data = _appComponent$data.componentModel) == null ? void 0 : _appComponent$data.componentType);
  }
  getInstalledComponents() {
    const installedApps = this.dm.platform.getInstalledApps();
    return installedApps.flatMap(app => app.components ?? []);
  }
  getCompType(editorPointer) {
    const compRef = this.editorPointerAPI.getDocumentPointer(editorPointer);
    const appData = this.dm.components.data.get(compRef);
    const compType = this.dm.components.getType(compRef);
    if (appData != null && appData.widgetId && TPAComponentTypes.includes(compType)) {
      return appData.widgetId;
    }
    return compType;
  }
  getAppDefId(componentId) {
    var _installedApps$find;
    const installedApps = this.dm.platform.getInstalledApps();
    const appDefId = (_installedApps$find = installedApps.find(app => {
      var _app$components;
      return (_app$components = app.components) == null ? void 0 : _app$components.find(component => component.componentId === componentId);
    })) == null ? void 0 : _installedApps$find.appDefinitionId;
    return appDefId;
  }
  extractComponentExtensionType(editorPointer) {
    var _appData$components2;
    const compRef = this.editorPointerAPI.getDocumentPointer(editorPointer);
    const compType = this.dm.components.getType(compRef);
    const builderCompData = this.dm.builder.components.getCompAppData(compType);
    const nonBuilderCompData = this.dm.components.data.get(compRef);
    const appDefinitionId = (builderCompData == null ? void 0 : builderCompData.appDefinitionId) || (nonBuilderCompData == null ? void 0 : nonBuilderCompData.appDefinitionId);
    const componentId = (builderCompData == null ? void 0 : builderCompData.componentId) || (nonBuilderCompData == null ? void 0 : nonBuilderCompData.widgetId);
    if (!appDefinitionId || !componentId) {
      return ManifestComponentExtensionType.UNKNOWN;
    }
    const appData = this.dm.platform.getAppDataByAppDefId(appDefinitionId);
    const appDataComponent = appData == null || (_appData$components2 = appData.components) == null ? void 0 : _appData$components2.find(c => c.componentId === componentId);
    return getExtensionType(appDataComponent == null ? void 0 : appDataComponent.type);
  }
}
export function getExtensionType(type) {
  switch (type) {
    case ComponentType.EDITOR_REACT_COMPONENT:
      {
        return ManifestComponentExtensionType.BUILDER;
      }
    case ComponentType.STUDIO_WIDGET:
      {
        return ManifestComponentExtensionType.BLOCKS;
      }
    case ComponentType.WIDGET_OUT_OF_IFRAME:
    case ComponentType.PAGE_OUT_OF_IFRAME:
      {
        return ManifestComponentExtensionType.OOI;
      }
  }
  return ManifestComponentExtensionType.UNKNOWN;
}
//# sourceMappingURL=ManifestHelpers.js.map